var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempleAppointments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.14551 4.16675C1.14551 3.78705 1.45331 3.47925 1.83301 3.47925H20.1663C20.546 3.47925 20.8538 3.78705 20.8538 4.16675V20.6667C20.8538 21.0464 20.546 21.3542 20.1663 21.3542H1.83301C1.45331 21.3542 1.14551 21.0464 1.14551 20.6667V4.16675ZM2.52051 4.85425V19.9792H19.4788V4.85425H2.52051Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1455 9.66675C12.1455 9.28705 12.4533 8.97925 12.833 8.97925H16.4997C16.8794 8.97925 17.1872 9.28705 17.1872 9.66675V16.0834C17.1872 16.4631 16.8794 16.7709 16.4997 16.7709H12.833C12.4533 16.7709 12.1455 16.4631 12.1455 16.0834V9.66675ZM13.5205 10.3542V15.3959H15.8122V10.3542H13.5205Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79199 1.64575C8.17169 1.64575 8.47949 1.95356 8.47949 2.33325V5.99992C8.47949 6.37961 8.17169 6.68742 7.79199 6.68742C7.4123 6.68742 7.10449 6.37961 7.10449 5.99992V2.33325C7.10449 1.95356 7.4123 1.64575 7.79199 1.64575Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.208 1.64575C14.5877 1.64575 14.8955 1.95356 14.8955 2.33325V5.99992C14.8955 6.37961 14.5877 6.68742 14.208 6.68742C13.8283 6.68742 13.5205 6.37961 13.5205 5.99992V2.33325C13.5205 1.95356 13.8283 1.64575 14.208 1.64575Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8125 9.66675C4.8125 9.28705 5.1203 8.97925 5.5 8.97925H9.16667C9.54636 8.97925 9.85417 9.28705 9.85417 9.66675V16.0834C9.85417 16.4631 9.54636 16.7709 9.16667 16.7709H5.5C5.1203 16.7709 4.8125 16.4631 4.8125 16.0834C4.8125 15.7037 5.1203 15.3959 5.5 15.3959H8.47917V10.3542H5.5C5.1203 10.3542 4.8125 10.0464 4.8125 9.66675Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72949 12.875C5.72949 12.4953 6.0373 12.1875 6.41699 12.1875H9.16699C9.54669 12.1875 9.85449 12.4953 9.85449 12.875C9.85449 13.2547 9.54669 13.5625 9.16699 13.5625H6.41699C6.0373 13.5625 5.72949 13.2547 5.72949 12.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempleAppointments);
export default __webpack_public_path__ + "static/media/temple-appointments.5bf9163b275d3c79b83aabebc1d3672c.svg";
export { ForwardRef as ReactComponent };